import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createPinia } from 'pinia'
import axios from 'axios'
const app = createApp(App)
/* ===== Pinia ===== */
const pinia = createPinia()
app.use(pinia)
/* ===== Axios 全局配置 ===== */
axios.defaults.baseURL = '/api'
// 请求拦截器：自动带 token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)
// 响应拦截器：token 失效统一处理
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)
/* ===== 注册 ===== */
app.use(router)
app.use(ElementPlus)
app.mount('#app')
/* ===== 修复 ResizeObserver 报错（Element Plus 常见） ===== */
const ignoreResizeObserverError = () => {
  const roError = /ResizeObserver loop completed with undelivered notifications/
  window.addEventListener('error', (event) => {
    if (roError.test(event.message)) {
      event.stopImmediatePropagation()
    }
  })
}
ignoreResizeObserverError()
